var sliders = {
	options: {
		//sliders_instances: [],
	},

  selectors: {
    	reviewsSlider: '.js-sliders-reviews',
		reviewsSliderNavButton: '.js-sliders-reviews-nav-button',
    	
		gallerySlider: '.block-gallery ul',
		gallerySliderNavButton: '.block-gallery-nav-button',
  },

	init: function () {
		var self = this;

		//Homepage
		self.reviewsSlider();
		self.gallerySlider();
	},

	reviewsSlider: function () {
   		const self = this;

		if (!jQuery(self.selectors.reviewsSlider).length) {
			return false;
		}

		let slider;

		jQuery(self.selectors.reviewsSlider).each(function () {
			slider = tns({
				container: this,
				items: 1,
				slideBy: 1,
				autoplay: false,
				loop: false,
				mouseDrag: true,
				controls: false,
				nav: true,
				gutter: 0,
				speed: 700,
			});
		});

		jQuery(self.selectors.reviewsSliderNavButton).on('click', function (e) {
			e.preventDefault();

			if (jQuery(this).data('controls') === 'prev') {
				slider.goTo('prev');
			} else {
				slider.goTo('next');
			}
		});
	},
	
	gallerySlider: function () {
   		const self = this;

		if (!jQuery(self.selectors.gallerySlider).length) {
			return false;
		}

		let slider;

		jQuery(self.selectors.gallerySlider).each(function () {
			slider = tns({
				container: this,
				items: 3,
				slideBy: 1,
				autoplay: false,
				loop: false,
				mouseDrag: true,
				controls: false,
				nav: true,
				gutter: 16,
				speed: 700,
				responsive: {
					0: {
						items: 1.5
					},
					400: {
						items: 2
					},
					1024: {
						items: 3
					}
				}
			});
		});

		jQuery(self.selectors.gallerySliderNavButton).on('click', function (e) {
			e.preventDefault();

			if (jQuery(this).data('controls') === 'prev') {
				slider.goTo('prev');
			} else {
				slider.goTo('next');
			}
		});
	},
};

export { sliders };
